import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http';
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points"
import { cuteToast } from '../../UI/cute';
import { useDispatch } from 'react-redux';
import { settingAction } from "../../../store/setting-store";
import { FiMail, FiUser, FiServer, FiHash, FiLock } from "react-icons/fi";

const Smtp = () => {

    const {sendRequest: insertSMTPDetails} = useHttp();
    const {sendRequest: getSettingData} = useHttp();
    const dispatch = useDispatch();

    const [details, setDetails] = useState({
        senderName: "",
        senderEmail: "",
        smtpHost: "",
        smtpUsername: "",
        smtpPassword: "",
        smtpPort: "",
    });

    useEffect(()=>{
        getSettingData({
            url: endPoints.getSettingData,
            method: "GET",
        },(response)=>{
            if(response.status === 200 && response.body.length > 0){
                const result = response.body
                const smtpData = result.filter((data)=>data.meta_type === "smtp_details");
                const meta_data = JSON.parse(smtpData[0].meta_data)
                if(meta_data){
                    setDetails(meta_data)
                    dispatch(settingAction.setSMTPDetails({ smtp_details:meta_data}));
                }
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const formHandler = (event) => {
        event.preventDefault();
        dispatch(settingAction.setSMTPDetails({ smtp_details:details}));

        insertSMTPDetails({
            url: endPoints.updateSmtpDetails,
            method: "POST",
            body: {
                ...details,
                type:"smtp_details"
            },
        },(response)=>{
            if(response.status === 200){
                cuteToast({
                    type: "success",
                    message: "Saved Successfully.",
                    timer: 5000,
                    title: "SMTP Settings",
                  });
            }
        })
    }

  return (
    <form onSubmit={formHandler}>
      <div className="st-form-card">
        <div className="st-card-head">
          <div className="st-card-head-icon st-icon-smtp">
            <FiMail size={19} />
          </div>
          <div>
            <h3 className="st-card-head-title">SMTP Configuration</h3>
            <p className="st-card-head-desc">Set up your email server for sending transactional emails</p>
          </div>
        </div>

        <div className="st-card-body">
          <div className="st-section-label">Sender Details</div>
          <div className="st-form-row">
            <div className="st-form-group">
              <label className="st-label">Sender Name *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiUser /></span>
                <Input
                  type="text"
                  inputClass="st-input st-input-with-icon"
                  value={details.senderName}
                  placeholder="Your name"
                  onChange={(e) =>
                    setDetails({ ...details, senderName: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="st-form-group">
              <label className="st-label">Sender Email *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiMail /></span>
                <Input
                  type="text"
                  inputClass="st-input st-input-with-icon"
                  value={details.senderEmail}
                  placeholder="you@example.com"
                  onChange={(e) =>
                    setDetails({ ...details, senderEmail: e.target.value })
                  }
                />
              </div>
            </div>
          </div>

          <hr className="st-divider" />

          <div className="st-section-label">Server Settings</div>
          <div className="st-form-row">
            <div className="st-form-group">
              <label className="st-label">Host Name *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiServer /></span>
                <Input
                  type="text"
                  inputClass="st-input st-input-with-icon"
                  value={details.smtpHost}
                  placeholder="smtp.example.com"
                  onChange={(e) =>
                    setDetails({ ...details, smtpHost: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="st-form-group">
              <label className="st-label">Port *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiHash /></span>
                <Input
                  type="number"
                  inputClass="st-input st-input-with-icon"
                  value={details.smtpPort}
                  placeholder="587"
                  onChange={(e) =>
                    setDetails({ ...details, smtpPort: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
          <div className="st-form-row">
            <div className="st-form-group">
              <label className="st-label">Username *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiUser /></span>
                <Input
                  type="text"
                  inputClass="st-input st-input-with-icon"
                  value={details.smtpUsername}
                  placeholder="SMTP username"
                  onChange={(e) =>
                    setDetails({ ...details, smtpUsername: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="st-form-group">
              <label className="st-label">Password *</label>
              <div className="st-input-wrapper">
                <span className="st-input-icon"><FiLock /></span>
                <Input
                  type="password"
                  inputClass="st-input st-input-with-icon"
                  value={details.smtpPassword}
                  placeholder="SMTP password"
                  onChange={(e) =>
                    setDetails({ ...details, smtpPassword: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="st-card-foot">
          <button className="st-btn-primary" type="submit">Save Details</button>
        </div>
      </div>
    </form>
  )
}

export default Smtp
